<template>
  <transition appear :enter-active-class="enterAnimation" :leave-active-class="leaveAnimation" mode="out-in">
    <span v-if="line" ref="spanElement" class="lf-animated-headline__content-rotation-line animated">
      <ApplyReplacementTags :html="line" />
    </span>
  </transition>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent, ref, onMounted, nextTick } from 'vue';
import { AnimatedHeadlineAnimationType } from '@/src/typings/enums/enums';
import ApplyReplacementTags from '@/src/components/ApplyReplacementTags.vue';

export default defineComponent({
  name: 'LfAnimatedHeadlineRotationLine',
  components: { ApplyReplacementTags },
  props: {
    line: {
      type: String
    },
    animation: {
      type: String as PropType<AnimatedHeadlineAnimationType>
    },
    isVisible: {
      type: Boolean
    },
    isFullWidth: {
      type: Boolean
    }
  },
  emits: ['setBounds'],
  setup(props, context) {
    const spanElement = ref<HTMLSpanElement | null>(null);

    const enterAnimation = computed(() => {
      let className = '';
      switch (props.animation) {
        case AnimatedHeadlineAnimationType.SLIDE:
          className = 'animated fadeInLeft';
          break;

        case AnimatedHeadlineAnimationType.FLIP:
          className = 'animated lf-animated-headline__content-rotation-line--flip-in';
          break;

        case AnimatedHeadlineAnimationType.SLIDE_DOWN:
          className = 'animated fadeInDown';
          break;

        case AnimatedHeadlineAnimationType.DROP_IN:
          className = 'lf-animated-headline__content-rotation-line--dropin-in';
          break;
      }
      return className;
    });

    const leaveAnimation = computed(() => {
      let className = '';
      switch (props.animation) {
        case AnimatedHeadlineAnimationType.SLIDE:
          className = 'animated faster fadeOutRight';
          break;

        case AnimatedHeadlineAnimationType.FLIP:
          className = 'animated lf-animated-headline__content-rotation-line--flip-out';
          break;

        case AnimatedHeadlineAnimationType.SLIDE_DOWN:
          className = 'animated fadeOutDown';
          break;

        case AnimatedHeadlineAnimationType.DROP_IN:
          className = 'lf-animated-headline__content-rotation-line--dropin-out';
          break;
      }
      return className;
    });

    onMounted(async () => {
      await nextTick();

      const bounds = spanElement.value?.getBoundingClientRect();
      if (bounds) {
        context.emit('setBounds', bounds);
      }
    });

    return {
      enterAnimation,
      leaveAnimation,
      spanElement
    };
  }
});
</script>
